import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthReducerState {
  loginDetails: any;
  token: string | null;
  isLoggedIn:boolean;
}

const initialState: AuthReducerState = {
  token: '',
  loginDetails: {},
  isLoggedIn:false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAccessTokenInReducer(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    setLoginDetails(state, action: PayloadAction<any>) {
      state.loginDetails = action.payload;
    },
    setIsLoggedIn(state, action: PayloadAction<boolean>) {
        state.isLoggedIn = action.payload;
      }
  },
});

export const { setAccessTokenInReducer, setLoginDetails ,setIsLoggedIn} = authSlice.actions;

export default authSlice.reducer;

